import { render, staticRenderFns } from "./LabelWithRequired.vue?vue&type=template&id=c3836eb6&scoped=true&"
import script from "./LabelWithRequired.vue?vue&type=script&lang=js&"
export * from "./LabelWithRequired.vue?vue&type=script&lang=js&"
import style0 from "./LabelWithRequired.vue?vue&type=style&index=0&id=c3836eb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3836eb6",
  null
  
)

export default component.exports